module.exports = __webpack_public_path__ + "static/media/ic-doc-xls.61b2549a.svg";